import dayjs from "dayjs"

export class PinkBookModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new PinkBookModel(), obj)

    newObj.startDate = obj.startDate ? dayjs(obj.startDate) : null

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
